<h2 mat-dialog-title>Editar pedido {{ pedido.orderCode }}</h2>

<form [formGroup]="form" mat-dialog-content class="form-container">
  <!-- Tipo de entrega -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Tipo de entrega</mat-label>
    <mat-select formControlName="deliveryType">
      <mat-option [value]="1">Retiro en local</mat-option>
      <mat-option [value]="2" *ngIf="tieneDelivery"
        >Envío a domicilio</mat-option
      >
    </mat-select>
    <mat-hint *ngIf="!tieneDelivery"
      >Los parámetros permiten solo retirar en local</mat-hint
    >
  </mat-form-field>

  <!-- Dirección -->
  <mat-form-field
    appearance="outline"
    class="full-width"
    *ngIf="form.get('deliveryType')?.value === 2"
  >
    <mat-label>Dirección</mat-label>
    <input matInput formControlName="deliveryAddress" />
  </mat-form-field>

  <!-- Notas del envío -->
  <mat-form-field
    appearance="outline"
    class="full-width"
    *ngIf="form.get('deliveryType')?.value === 2"
  >
    <mat-label>Notas del envío</mat-label>
    <textarea matInput rows="2" formControlName="deliveryNotes"></textarea>
  </mat-form-field>

  <h3>Productos</h3>

  <div formArrayName="items" class="items-container">
    <div
      *ngFor="let item of items.controls; let i = index"
      [formGroupName]="i"
      class="item-row"
    >
      <div class="item-title">
        {{ obtenerNombreProducto(item.value.productId) }}

        <button
          mat-icon-button
          class="delete-button"
          type="button"
          (click)="eliminarItem(i)"
          matTooltip="Eliminar producto"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <div class="item-fields">
        <mat-form-field appearance="outline">
          <mat-label>Cantidad</mat-label>
          <input matInput type="number" formControlName="quantity" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Notas</mat-label>
          <input matInput formControlName="notes" />
        </mat-form-field>
      </div>

      <div
        class="toppings-container"
        *ngIf="!esCategoriaSinToppings(item.get('productId')?.value)"
      >
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Toppings</mat-label>

          <mat-select multiple formControlName="toppings">
            <mat-option *ngFor="let t of toppingsDisponibles" [value]="t.id">
              {{ t.name }} – ${{ t.price }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <h3 class="section-title">Agregar producto</h3>

  <div class="add-item-row">
    <mat-form-field appearance="outline" class="add-product-select">
      <mat-label>Producto</mat-label>
      <mat-select #productoSelect>
        <mat-option
          *ngFor="let producto of productosDisponibles"
          [value]="producto"
        >
          {{ producto.name }} – ${{ producto.price }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button
      mat-fab
      color="primary"
      class="add-button"
      (click)="
        agregarProducto(productoSelect.value); productoSelect.value = null
      "
      [disabled]="!productoSelect.value"
      matTooltip="Agregar producto"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</form>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="items.length === 0"
  >
    Guardar cambios
  </button>
</mat-dialog-actions>
